import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const Hinges = ({ value, onChange, label = 'Hinges:', passSelectedDoor, disabled = false }) => {
    const [selectedHinges, setSelectedHinges] = useState(value || "Left");
    const [doorData, setDoorData] = useState(null);

    const handleOperatingSideLite = () => {
        const element = document.getElementById('OperatingSideLite');
        if (element) {
            if (
                ((selectedHinges === 'Left' ) && (doorData && [3,4].includes(doorData.id))) || 
                ((selectedHinges === 'Right') && (doorData && [2,4].includes(doorData.id)))
            ) {
                element.style.display = "block";
                const label = element.previousElementSibling;
                if (label) label.style.display = "block";
            } else {
                element.style.display = "none";
                const label = element.previousElementSibling;
                if (label) label.style.display = "none";
            }
        }
    };

    useEffect(() => {
 
        if (passSelectedDoor) {
            setDoorData(passSelectedDoor);
        }
      }, [passSelectedDoor]); 

      useEffect(() => {
        if (doorData) {
            handleOperatingSideLite();
        }
    }, [doorData, selectedHinges]);

    const handleHingesChange = (e) => {
        const newValue = e.target.value;
        setSelectedHinges(newValue);
        onChange(newValue);
        handleOperatingSideLite();

    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="Hinges">{label}</label>
            <select
                disabled={disabled}
                id="Hinges"
                value={selectedHinges}
                onChange={handleHingesChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Left">{selectedHinges === "Left" ? "Left ✔" : "Left"}</option>
                <option value="Right">{selectedHinges === "Right" ? "Right ✔" : "Right"}</option>
            </select>
        </div>
    );
};

export default Hinges;
